"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var PriceModeToggle =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PriceModeToggle, _PureComponent);

  function PriceModeToggle() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, PriceModeToggle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(PriceModeToggle)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.setToTotal = function () {
      return _this.props.setPriceMode('total');
    };

    _this.setToItem = function () {
      return _this.props.setPriceMode('item');
    };

    return _this;
  }

  (0, _createClass2.default)(PriceModeToggle, [{
    key: "render",
    value: function render() {
      var priceMode = this.props.priceMode;
      return _react.default.createElement("div", {
        className: "btn-group"
      }, _react.default.createElement("button", {
        onClick: this.setToTotal,
        className: "btn btn-default ".concat(priceMode === 'total' ? 'active' : '')
      }, "Total Price"), _react.default.createElement("button", {
        onClick: this.setToItem,
        className: "btn btn-default ".concat(priceMode === 'item' ? 'active' : '')
      }, "Price Per Item"));
    }
  }]);
  return PriceModeToggle;
}(_react.PureComponent);

exports.default = PriceModeToggle;
PriceModeToggle.defaultProps = {
  priceMode: 'total'
};